import React, { useState, useEffect } from "react";
import { Spinner } from "reactstrap";
import swal from "sweetalert";
import combinedServices from "../../../../shared/services/user-service";
import getLocalData from "../../../../shared/localStorage/getData";

const PaypalCreds = ({ storeID }) => {
  const [clientId, setClientId] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [hasExisting, setHasExisting] = useState(false);
  const [storeName, setStoreName] = useState("");
  const [currentUserId, setCurrentUserId] = useState(null);

  useEffect(() => {
    if (storeID) {
      loadExistingCreds();
      loadStoreInfo();
    }
    const loginUserData = getLocalData("user_info", "all").userData
      .login_user_detail.data.user.id;
    setCurrentUserId(loginUserData);
  }, [storeID]);

  const loadExistingCreds = async () => {
    try {
      const response = await combinedServices.getStorePaypalCreds(storeID);
      console.log("GET API Response:", response); // Debug log
      if (response.status === 200 && response.data) {
        setClientId(response.data.data.paypal_client_id || "");
        setClientSecret(response.data.data.paypal_client_secret || "");
        setHasExisting(true);
      }
    } catch (error) {
      console.log("GET API Error:", error); // Debug log
      setHasExisting(false);
    }
  };

  const loadStoreInfo = async () => {
    try {
      const response = await combinedServices.getstorebyid(storeID);
      if (response.status === 200 && response.data?.data) {
        setStoreName(response.data.data.storename || "");
      }
    } catch (error) {
      console.error("Error loading store info:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!clientId || !clientSecret) {
      swal("Please fill all fields");
      return;
    }

    setIsLoading(true);
    const data = {
      storeid: storeID,
      paypal_client_id: clientId,
      paypal_client_secret: clientSecret,
      store_name: storeName,
      addedby: currentUserId,
    };

    try {
      const response = hasExisting
        ? await combinedServices.updateStorePaypalCreds(data)
        : await combinedServices.addStorePaypalCreds(data);

      if (response.status === 200 || response.status === 201) {
        const action = hasExisting ? "updated" : "added";
        const responseData = response.data.data || response.data;
        swal(`PayPal credentials ${action} successfully`);

        // Reload data from API to get updated values
        await loadExistingCreds();
      } else {
        swal("Error", response.msg, "error");
      }
    } catch (error) {
      swal("Error", "Something went wrong", "error");
    }
    setIsLoading(false);
  };

  return (
    <div className="row">
      <div className="col-lg-8 col-md-10 mx-auto">
        <div className="card">
          <div className="card-header">
            <h4 className="mb-0">
              {hasExisting
                ? "Update PayPal Credentials"
                : "Add PayPal Credentials"}
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">PayPal Client ID</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter PayPal Client ID"
                    value={clientId}
                    onChange={(e) => setClientId(e.target.value)}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">PayPal Client Secret</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter PayPal Client Secret"
                    value={clientSecret}
                    onChange={(e) => setClientSecret(e.target.value)}
                  />
                </div>
              </div>
              <div className="text-center mt-4">
                {isLoading ? (
                  <Spinner color="primary" />
                ) : (
                  <button type="submit" className="btn btn-primary px-4">
                    {hasExisting ? "Update" : "Add"} Credentials
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaypalCreds;
